/* Action Types */
export const LOAD_SEARCH_RESULTS_FAIL = 'la/domain/searchResults/LOAD_FAIL';
export const LOAD_SEARCH_RESULTS_REQUEST = 'la/domain/searchResults/LOAD_REQUEST';
export const LOAD_SEARCH_RESULTS_SUCCESS = 'la/domain/searchResults/LOAD_SUCCESS';
export const SET_USE_GEO_LOCATION = 'la/domain/searchResults/SET_USE_GEO_LOCATION';

export const LOAD_MORE_SEARCH_RESULTS_FAIL = 'la/domain/searchResults/LOAD_MORE_FAIL';
export const LOAD_MORE_SEARCH_RESULTS_REQUEST = 'la/domain/searchResults/LOAD_MORE_REQUEST';
export const LOAD_MORE_SEARCH_RESULTS_SUCCESS = 'la/domain/searchResults/LOAD_MORE_SUCCESS';

export const DEFAULT_ARCHIVE_STATUSES = ['sold', 'passed', 'done'];
export const DEFAULT_LIVE_STATUSES = ['upcoming', 'live', 'online'];
export const DEFAULT_SORT_ORDER = '-relevance';
